import {Component, HostListener, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PhotoService} from '../services/photo.service';
import {Location} from '@angular/common';
import {RatingService} from '../services/rating.service';
import {CommentService} from '../services/comment.service';
import {ToastrService} from 'ngx-toastr';
import {Photo} from '../../../shared/models/cameralla-photo.model';
import {CamerallaAuthService} from '../../../shared/services/authentication-services/cameralla-auth.service';
import * as $ from 'jquery';

@Component({
    selector: 'app-photo-review',
    templateUrl: './photo-review.component.html',
})
export class PhotoReviewComponent implements OnInit {
    photoDetails: Photo;
    criterion = [
        {name: 'general', value: 0.0},
        {name: 'vision', value: 0.0},
        {name: 'composition', value: 0.0},
        {name: 'cameraSettings', value: 0.0},
        {name: 'editing', value: 0.0},
        {name: 'presentation', value: 0.0}];

    reviewObject = {
        customerId: 0,
        photoId: 0,
        vision_text: null,
        composition_text: null,
        cameraSettings_text: null,
        editing_text: null,
        presentation_text: null,
        general_text: null,
    };

    isLeftVisible = true;
    photosByUser: Photo[] = [];
    currentFeedback: any;
    localUserId: number;

    constructor(private location: Location,
                private photoService: PhotoService,
                private router: Router,
                private route: ActivatedRoute,
                private commentService: CommentService,
                private ratingService: RatingService,
                private toastr: ToastrService,
                private authService: CamerallaAuthService) {
    }

    ngOnInit() {
        this.localUserId = +this.authService.getLocalUserInfo()['id'];
        this.reviewObject.customerId = +this.authService.getLocalUserInfo()['id'];
        const paramId = this.route.snapshot.paramMap.get('id');

        this.photoService.getPhotoDetails(paramId, false).then(
            response => {
                if (response['IsSuccess']) {
                    this.photoDetails = response['Data'];
                    this.reviewObject.photoId = this.photoDetails['id'];

                    this.photoService.getPhotosByUserId(this.photoDetails['customerId'], this.photoDetails['id']).toPromise().then(
                        photos => {
                            this.photosByUser = photos['Data'];
                        },
                        error => {
                            console.log('getPhotosByUserId error ' + error);
                        }
                    );
                }
            },
            error => {
                console.log('getPhotoDetails error ' + error);
            }
        );

        this.currentFeedback = this.photoService.getPhotoDetails(paramId, false);
    }

    listenFromReview($event) {
        this.criterion = $event[1];
        this.switchView();
    }

    switchView() {
        this.isLeftVisible = !this.isLeftVisible;
        $('html, body').animate({scrollTop: 0}, 'slow');
    }
}
